module.exports = "\n<app-pageheader></app-pageheader>\n\n\n  <app-pagefooter></app-pagefooter>\n"